import { render, staticRenderFns } from "./BrandMark.vue?vue&type=template&id=5e4380e1&scoped=true"
import script from "./BrandMark.vue?vue&type=script&lang=js"
export * from "./BrandMark.vue?vue&type=script&lang=js"
import style0 from "./BrandMark.vue?vue&type=style&index=0&id=5e4380e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4380e1",
  null
  
)

export default component.exports